import React from "react";

class CreditClosed extends React.Component {

    state = { }

    render() {

        return (
            <div>Кредит закрыт. Что здесь показывать?</div>
        );
    }
}

export default CreditClosed;



// WEBPACK FOOTER //
// ./src/components/CreditClosed.js